// eslint-disable-next-line import/prefer-default-export
export var DEFAULT_LOCALE = "en-US";

//# sourceMappingURL=locales.js.map